import { Box, Typography } from '@mui/material';
import * as React from 'react';
import type { JSX } from 'react';

import { Flexbox } from '../Flexbox';
import { StandardLayoutProps } from '../types';

export interface FormSectionProps extends Omit<StandardLayoutProps, 'title'> {
    title: string | JSX.Element;
}

export const FormSection: React.FunctionComponent<FormSectionProps> = ({ title, children, ...props }) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    padding: '24px 0',
                    display: 'grid',
                    gridTemplateColumns: '250px 1fr',
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >
            <Typography component={'div'} variant="h3" color="textSecondary">
                {title}
            </Typography>
            <Flexbox
                gap={24}
                sx={{
                    flexDirection: 'column',
                }}
            >
                {children}
            </Flexbox>
        </Box>
    );
};
